import React, {Component} from "react"
import styled from "styled-components"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import {getThumbnailImage} from "@irati/utils/images"

import Image from "./styled/Image"

const StyledDiv = styled.div`
  display: flex;
  margin: 5px;
`

interface Props extends InjectIntl {
  onClick: () => void,
  thumbnailImage: string
}

class RewardSelect extends Component<Props> {
  render() {
    const {formatMessage, onClick, thumbnailImage} = this.props

    return (
      <StyledDiv>
        <Image
          onClick={onClick}
          src={getThumbnailImage(thumbnailImage)}
          alt={formatMessage({id: "recognition.reward.picker.image.alt"})} />
      </StyledDiv>
    )
  }
}

export default injectIntl(RewardSelect)
